<template>
  <div>
    <div v-if="!$isFlag && isShow" class="headerWeb">
      <p class="p1"><span />{{ titleArray[0] }}</p>
      <p class="p2">
        {{ titleArray[1] }} /
        <span @click="spanClick(titleArray[2])">{{ titleArray[2] }}</span>/
        <span :class="titleArray.length >= 5 ? 'hasFourMenu' : ''" @click="spanClick(titleArray[3])">{{ titleArray[3] }}</span>
        <span v-if="titleArray.length >= 5"> / {{ titleArray[4] }}</span>
      </p>
    </div>
    <div v-if="$isFlag && titleMb" class="headerH5">
      <van-nav-bar
        :title="titleMb"
        :left-arrow="leftArrow"
        @click-left="onClickLeft"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  components: {},
  props: {
    typeNext: {
      type: String,
      default: () => ''
    },
    titleArray: {
      type: Array,
      default: () => []
    },
    isShow: {
      type: Boolean,
      default: () => true
    },
    titleMb: {
      type: String,
      default: () => ''
    },
    leftArrow: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    spanClick(key) {
      if (key == '账号自助管理') {
        this.$router.push('/accountCenter/index')
      }
      if (key == '账号管理中心') {
        this.$router.push('/accountCenter/accountList/accountInfo')
      }
      if (key.includes('忘记账号')) {
        this.$router.push('/accountCenter/accountSelf/accountRetrieval')
      }
      if (key.includes('手机号管理')) {
        this.$router.push('/accountCenter/accountList/phoneManage')
      }
    },
    onClickLeft() {
      if (this.typeNext === 'click') {
        this.$emit('navBarClick')
      } else {
        if (this.routerUrl) {
          if (this.routerUrl === '-2') {
            this.$router.go(-2)
            return
          }
          this.$router.push(this.routerUrl)
        } else {
          this.$router.go(-1)
        }
      }
    }
  }
}
</script>
<style lang="stylus">
@import '~assets/css/reset.styl';
</style>
<style lang="stylus" scoped>
// h5
  .headerH5 {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 9999;
    max-width: 750px
    ::v-deep .van-nav-bar__content {
      height: 1.08rem;
    }
    ::v-deep .van-nav-bar .van-icon {
      color: black;
      font-size: 0.45rem;
    }
    ::v-deep .van-nav-bar__title {
      color: #333333;
      font-size: 0.36rem;
      height: 1.08rem;
      line-height: 1.08rem;
    }
  }
// web
  .headerWeb {
    font-size: 0.28rem;
    margin: 0.2rem 0.8rem;
    color: #4c4948;
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0 .3rem  0;
    box-sizing: border-box;
    align-items: flex-end;
    border-bottom: #dedfdf 1px solid;
    .p1 {
      font-size: 0.4rem;
      span {
        display: inline-block;
        width: 0.1rem;
        height: 0.5rem;
        background: #606de2;
        vertical-align: sub;
        border-radius: 60px;
        margin-right: 0.15rem;
      }
    }
    .p2 {
      // font-weight: bold;
      color: #8b8686;
      font-size: 0.32rem;
      span:nth-child(1){
        color: #8b8686
        cursor pointer
        &:hover{
          color: #616edf
          }
      }
      span {
        color: #616edf;
      }
    }
    span.hasFourMenu {
      color: #8b8686
      cursor pointer
      &:hover{
        color: #616edf
        }
    }
  }
</style>
